// authentication
export const LOGIN_PATH = '/auth/login';
export const LOGOUT_PATH = '/auth/logout';
export const RECOVER_PASSWORD_PATH = '/admin/user/recover-password';
export const REFRESH_TOKEN_PATH = '/admin/user/refresh-session';

// user
export const GET_USER_PATH = '/user';

// admin
export const GET_ADMINS_PATH = '/user/admin/list/filterBy';
export const CREATE_ADMIN_PATH = '/user/admin';
export const RESETPASSWORD_ADMIN_PATH = '/user/admin/activate-need-change-password/{id}';
export const RECOVER_PASSWORD_ADMIN_PATH = 'user/admin/change-password';
export const DELETE_ADMIN_PATH = '/user/admin/remove-access/{id}';
export const EDIT_ADMIN_PATH = '/user/admin/updateUser/{id}';
export const ACTIVATE_ADMIN_PATH = '/user/admin/grant-access/{id}';

// inspectors
export const GET_INSPECTORS_PATH = '/user/inspector/list/filterBy';
export const CREATE_INSPECTOR_PATH = '/user/inspector';
export const RESETPASSWORD_INSPECTOR_PATH = '/user/inspector/activate-need-change-password/{id}';
export const RECOVER_PASSWORD_INSPECTOR_PATH = 'user/inspector/change-password';
export const DELETE_INSPECTOR_PATH = '/user/inspector/remove-access/{id}';
export const ACTIVATE_INSPECTOR_PATH = '/user/inspector/grant-access/{id}';
export const EDIT_INSPECTOR_PATH = '/user/inspector/updateUser/{id}';



// supervisor
export const GET_SUPERVISORS_PATH = '/user/overseer/list/filterBy';
export const CREATE_SUPERVISOR_PATH = '/user/overseer';
export const RESETPASSWORD_SUPERVISOR_PATH = '/user/overseer/activate-need-change-password/{id}';
export const RECOVER_PASSWORD_SUPERVISOR_PATH = 'user/overseer/change-password';
export const DELETE_SUPERVISOR_PATH = '/user/overseer/remove-access/{id}';
export const EDIT_SUPERVISOR_PATH = '/user/overseer/updateUser/{id}';
export const ACTIVATE_SUPERVISOR_PATH = '/user/overseer/grant-access/{id}';


// inspectionsApplication
export const GET_INSPECTIONAPPLICATIONS_PATH= '/inspection/list/filterBy';
export const GET_INSPECTIONAPPLICATION_DETAIL_PATH= '/inspection/getDetail/{id}';
export const CREATE_INSPECTIONAPPLICATIONS_PATH = '/inspection/uploadExcel';
